import { render, staticRenderFns } from "./DetailsSectionOperationHistory.vue?vue&type=template&id=a0dbbcf6&"
import script from "./DetailsSectionOperationHistory.vue?vue&type=script&lang=js&"
export * from "./DetailsSectionOperationHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports